import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL_V3, post } from "../api";

export interface BillCableVerifyPayload {
  service_type: string;
  smartcard_number: string;
  phone: string;
}

export interface BillCablePlan {
  code?: string;
  plan_code?: string;
  name?: string;
  plan_name?: string;
  price?: number | string;
  amount?: number | string;
  [key: string]: unknown;
}

export interface BillCableVerifyResult {
  customer_name: string;
  plans: BillCablePlan[];
}

/**
 * Verify a smartcard number for cable TV (returns the customer name + plans)
 * via the provider-agnostic bills layer (/v3/bills).
 */
function useBillCableVerify(
  options?: MutationOptions<
    APIResponse<BillCableVerifyResult>,
    APIError,
    BillCableVerifyPayload
  >
) {
  const {
    mutate: verifySmartcard,
    isLoading: verifyingSmartcard,
    isError: isVerifyError,
    error: verifyError,
    data: verifyResponse,
    reset: resetVerify,
  } = useMutation<APIResponse<BillCableVerifyResult>, APIError, BillCableVerifyPayload>(
    (payload) =>
      post(API_URL_V3 + "/bills/cable-tv/verify", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    verifySmartcard,
    verifyingSmartcard,
    isVerifyError,
    verifyError,
    verifyResponse,
    resetVerify,
  };
}

export default useBillCableVerify;
